"use client";
import { Zap, Lock, DollarSign } from "lucide-react";
import { useTranslation } from "@/components/language/hooks/useTranslation";

export default function AboutRemitCirclePage() {
  const { t, tm } = useTranslation();

  const features = tm("about.features") as {
    title: string;
    description: string;
  }[];

  const featureIcons = [Zap, DollarSign, Lock];

  return (
    <main className="relative overflow-hidden bg-brand-text">
      <section className="relative flex flex-col px-4 lg:px-0 mx-auto lg:max-w-4xl xl:max-w-6xl 3xl:max-w-[1432px] py-5 sm:py-20 xl:py-24">
        <div className="about-content">

          <h1 className="text-5xl lg:text-6xl font-bold leading-tight text-brand-card mb-5 mt-5 flex items-center justify-center 3xl:pb-10 3xl:text-8xl">
            Vell
            <span className="ml-4 text-transparent bg-clip-text bg-brand-card">
              {" "}Service
            </span>
          </h1>

          <div className="space-y-5 text-lg leading-relaxed 3xl:text-2xl text-brand-card text-center lg:text-left">
            <p className="leading-relaxed text-brand-card">{t("about.description.p1")}</p>

            <p className="leading-relaxed text-brand-card">{t("about.description.p2")}</p>

            <p className="leading-relaxed text-brand-card">{t("about.description.p3")}</p>
          </div>
        </div>

        <div className="mt-16 about-us-features">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {features?.map((feature, index) => {
              const Icon = featureIcons[index];

              return (
                <div
                  key={index}
                  className="bg-transparent global-border-radius p-8 border border-brand-grey hover:border-brand-teal transition"
                >
                  <div className="w-12 h-12 global-border-radius bg-brand-grey flex items-center justify-center mb-4 mx-auto lg:mx-0 3xl:w-16 3xl:h-16">
                    <Icon className="w-6 h-6 text-brand-card 3xl:w-8 3xl:h-8" />
                  </div>

                  <h2 className="mb-2 text-xl font-semibold text-brand-card 3xl:text-[2rem] text-center lg:text-left">{feature.title}</h2>

                  <p className="text-brand-card/80 3xl:text-xl text-center lg:text-left">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}
